import { render, staticRenderFns } from "./ArtistTile.vue?vue&type=template&id=0b30768a&scoped=true"
import script from "./ArtistTile.vue?vue&type=script&lang=ts"
export * from "./ArtistTile.vue?vue&type=script&lang=ts"
import style0 from "./ArtistTile.vue?vue&type=style&index=0&id=0b30768a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30768a",
  null
  
)

export default component.exports